export enum Solutions {
  IndustrialVending = 1,
  ToolManegament = 2,
  Luggage = 3,
  Office = 4
}